@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../constants/spacing.module.less';

.modal-body {
  margin-left: @space-48;
  margin-right: @space-48;
  margin-top: @space-16;
}

.error-modal {
  width: 420px;
}

.loading-indicator {
  height: 120px;
}

.modal-footer {
  line-height: 16px;
}

.modification-date {
  position: absolute;
  margin-top: @space-16;
  font-size: 12px;
  font-weight: @normal;
  line-height: 12px;
  color: var(--default--disabled--text-color--4);
}

.radio-list {
  display: flex;
  margin-top: @space-24;

  .radio-item {
    margin-right: @space-32;
    padding: @space-0;
  }
}
